import { Controller } from '@hotwired/stimulus';
import { leave, toggle } from 'el-transition';

// Connects to data-controller="profile-dropdown"
export default class extends Controller {
  static targets = ['items', 'menuArea']

  connect() {
    document.body.addEventListener('click', (e) => {
      if (!this.element.contains(e.target)) {
        leave(this.itemsTarget)
      }
    })
  }

  toggle(e) {
    toggle(this.itemsTarget)
  }
}
